import { graphql } from 'gatsby';
import React from 'react';

import { Container, Stack, Typography } from '@mui/material';
import {
  useContentfulInspectorMode, useContentfulLiveUpdates
} from '../shared/hooks/contentful';

import Feature, { FeatureProps } from './feature';
import { ContentfulAsset, Kicker } from './ui';

export interface FeatureListProps {
  kicker?: string
  kickerIcon?: ContentfulAsset
  heading: string
  text?: string
  contentful_id: string
  featureListContent: FeatureProps[]
}

export default function FeatureList(props: FeatureListProps) {
  const inspectorProps = useContentfulInspectorMode();
  // Live updates for this component
  const data = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });

  const hasContent =
    data.featureListContent && data.featureListContent.length > 0

  return (
    <Stack
      direction="column"
      gap={{ xs: 5, md: 2 }}
      {...inspectorProps({
        entryId: props.contentful_id,
        fieldId: 'content',
      })}
    // divider={
    //   <Divider
    //     orientation="horizontal"
    //     flexItem
    //     sx={{ borderColor: theme.palette.grey[800] }}
    //   />
    // }
    >
      {data.kicker || data.heading || data.text ? (
        <Container sx={{ pt: 2 }}>
          <Stack
            rowGap={3}
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            {data.kicker ? (
              <div>
                <Kicker label={data.kicker} icon={data.kickerIcon}
                  {...inspectorProps({
                    entryId: props.contentful_id,
                    fieldId: 'kicker',
                  })} />
              </div>
            ) : (
              <></>
            )}

            {data.heading ? (
              <Typography
                variant="h2"
                sx={{
                  color: "#160637",
                  textAlign: { xs: "center", sm: "center", md: "inherit" },
                }}
                {...inspectorProps({
                  entryId: props.contentful_id,
                  fieldId: 'heading',
                })}
              >
                {data.heading}
              </Typography>
            ) : (
              <></>
            )}

            {data.text ? (
              <Typography
                variant="body1"
                sx={{
                  color: "#666679",
                  fontWeight: 400,
                  maxWidth: !hasContent ? "640px" : undefined,
                  textAlign: "center",
                }}
                {...inspectorProps({
                  entryId: props.contentful_id,
                  fieldId: 'text',
                })}
              >
                {data.text}
              </Typography>
            ) : (
              <></>
            )}
          </Stack>
        </Container>
      ) : (
        <></>
      )}

      {hasContent ? (
        data.featureListContent.map((feature, i) => {
          return <Feature index={i} key={feature.id} {...feature} />
        })
      ) : (
        <></>
      )}
    </Stack>
  )
}

export const query = graphql`
  fragment HomepageFeatureListContent on ContentfulHomepageFeatureList {
    id
    kicker
    __typename
    contentful_id
    kickerIcon {
      id
      url
      title
      __typename
      contentful_id
      
      localFile {
        childImageSharp { 
          gatsbyImageData(height: 20, width: 20)
        }
      }
    }
    heading
    text
    featureListContent: content {
      ...HomepageFeatureContent
    }
  }
`
